import { createRoutine } from 'redux-saga-routines';

export const createGuest = createRoutine('CREATE_GUEST');

export const updateGuest = createRoutine('UPDATE_GUEST');

export const mergeGuest = createRoutine('MERGE_GUEST');

export const deleteGuest = createRoutine('DELETE_GUEST');

export const fetchGuestForView = createRoutine('FETCH_GUEST_VIEW');

export const fetchGuestForMerge = createRoutine('FETCH_GUEST_MERGE');

export const createHouseholdMember = createRoutine('CREATE_HOUSEHOLD_MEMBER');

export const updateHouseholdMember = createRoutine('UPDATE_HOUSEHOLD_MEMBER');

export const deleteHouseholdMember = createRoutine('DELETE_HOUSEHOLD_MEMBER');

export const fetchGuestRelationship = createRoutine('FETCH_GUEST_RELATIONSHIP');

export const fetchRelatedGuestsForField = createRoutine(
  'FETCH_RELATED_GUESTS_FOR_FIELD'
);

export const fetchGuestVisits = createRoutine('FETCH_GUEST_VISITS');

export const fetchGuestVisitTrack = createRoutine('FETCH_GUEST_VISIT_TRACK');

export const fetchGuestAuditLogs = createRoutine('FETCH_GUEST_AUDIT_LOGS');

export const fetchGuestNotes = createRoutine('FETCH_GUEST_NOTES');

export const fetchGuestReservations = createRoutine('FETCH_GUEST_RESERVATIONS');

export const createGuestNote = createRoutine('CREATE_GUEST_NOTE');

export const updateGuestNote = createRoutine('UPDATE_GUEST_NOTE');
export const deleteGuestNote = createRoutine('DELETE_GUEST_NOTE');

export const fetchGuestFiles = createRoutine('FETCH_GUEST_FILES');

export const createGuestFile = createRoutine('CREATE_GUEST_FILE');

export const deleteGuestFile = createRoutine('DELETE_GUEST_FILE');

export const fetchUserRoleOptions = createRoutine('FETCH_USER_ROLE_OPTIONS');

export const fetchUserLocationOptions = createRoutine(
  'FETCH_USER_LOCATION_OPTIONS'
);

export const fetchAssociatedDomainOptions = createRoutine(
  'FETCH_USER_ASSOCIATED_DOMAIN_OPTIONS'
);

export const fetchAssociationLinkOptions = createRoutine(
  'FETCH_ASSOCIATION_LINK_OPTIONS'
);
